'use strict';

function _BankController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this._getBankListCallback = null;
  this._getBankAccountsCallback = null;
  this._getFinancialBankAccountsCallback = null;
  this._initializedBanksModelPromise = $.Deferred();
  this._initializedAccountsModelPromise = $.Deferred();
  this._initializedFinancialAccountsModelPromise = $.Deferred();
  this._banks = [];
  this._accounts = [];
  this._financialAccounts = [];
  this._errorHandler = null;

  this.init = function () {};

  this._initRootModel = function () {
    if (!this.presenter.models.banking) {
      this.presenter.createModel('banking');
    }
  };

  this._DEBUG = false;
  if (this._DEBUG) this.pageName = '[BankController]';

  this._onBanksModelReady = function (callback, data, response) {
    this._removeGetBankListCallback();
    if (!!this._connectionIssueConfig && this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'account.index_banks' }, { productLabel: this.productConfig.name });
      }
    } else if (response === 200) {
      this._instantiateBanksArray(callback);
      this._initializedBanksModelPromise.resolve();
    }
  };

  this._removeGetBankListCallback = function () {
    if (this._getBankListCallback) {
      this.presenter.removeCallbackFromAction('account.index_banks', this._getBankListCallback);
    }
  };

  this._instantiateBanksArray = function (callback) {
    var _this = this;

    this._banks = this.presenter.getModelProperty('banking.banks.banks');
    this._banks = this._banks ? this._banks.map(function (bank) {
      return new Bank(_this.presenter, bank);
    }) : [];
    if (typeof callback === 'function') {
      callback(this._banks);
    }
  };

  this._onAccountsModelReady = function (callback, data, response) {
    this._removeGetBankAccountsCallback();
    if (!!this._connectionIssueConfig && this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'account.index_bank_accounts' }, { productLabel: this.productConfig.name });
      }
    } else if (response === 200) {
      this._instantiateAccountsArray(callback);
      this._initializedAccountsModelPromise.resolve();
    }
  };

  this._removeGetBankAccountsCallback = function () {
    if (this._getBankAccountsCallback) {
      this.presenter.removeCallbackFromAction('account.index_bank_accounts', this._getBankAccountsCallback);
    }
  };

  this._instantiateAccountsArray = function (callback) {
    var _this2 = this;

    this._accounts = this.presenter.getModelProperty('banking.accounts.bank_accounts');
    if (this._accounts) {
      if (!this._errorHandler) this._errorHandler = new PlaidErrorHandler(this.presenter);
      this._accounts = this._accounts.map(function (acct) {
        return new BankAccount(_this2.presenter, acct, _this2._errorHandler);
      });
    } else {
      this._accounts = [];
    }
    if (typeof callback === 'function') {
      callback(this._accounts);
    }
  };

  this.updateErrorConfigs = function (configs) {
    if (!this._errorHandler) this._errorHandler = new PlaidErrorHandler(this.presenter);
    $.extend(this._errorHandler._configs, configs);
  };

  this.getBankList = function (callback) {
    var _this3 = this;

    this._initRootModel();
    if (!this.presenter.getModelProperty('banking.banks')) {
      this._getBankListCallback = this.presenter.addCallbackToAction('account.index_banks', this._onBanksModelReady.bind(this, callback));
      this.presenter.createModel('banking.banks', { action: 'account.index_banks' });
    } else if (!this.presenter.getModelProperty('banking.banks._initialized') && typeof callback === 'function') {
      this._getBankListCallback = this.presenter.addCallbackToAction('account.index_banks', this._onBanksModelReady.bind(this, callback));
      $.when(this._initializedBanksModelPromise).then(function () {
        _this3._instantiateBanksArray(callback);
      });
    } else {
      if (typeof callback === 'function') {
        this._instantiateBanksArray(callback);
      }
      this._initializedBanksModelPromise.resolve();
    }
  };

  this.getBankById = function (bankId, callback) {
    this._initRootModel();
    this.getBankList(function (bankId, callback) {
      var bankObj = this._banks.find(function (bank) {
        return bank.id === bankId;
      });
      if (typeof callback === 'function') {
        callback(bankObj);
      }
    }.bind(this, bankId, callback));
  };

  this.getBankAccounts = function (callback) {
    var _this4 = this;

    this._initRootModel();
    if (!this.presenter.getModelProperty('banking.accounts')) {
      this._getBankAccountsCallback = this.presenter.addCallbackToAction('account.index_bank_accounts', this._onAccountsModelReady.bind(this, callback));
      this.presenter.createModel('banking.accounts', { action: 'account.index_bank_accounts' });
    } else if (!this.presenter.getModelProperty('banking.accounts._initialized') && typeof callback === 'function') {
      this._getBankAccountsCallback = this.presenter.addCallbackToAction('account.index_bank_accounts', this._onAccountsModelReady.bind(this, callback));
      $.when(this._initializedAccountsModelPromise).then(function () {
        _this4._instantiateAccountsArray(callback);
      });
    } else if (typeof callback === 'function') {
      this._instantiateAccountsArray(callback);
    }
  };

  this.getBankAccountById = function (acctId, callback) {
    this._initRootModel();
    this.getBankAccounts(function (acctId, callback) {
      var accountObj = this._accounts.find(function (acct) {
        return acct.id === acctId;
      });
      if (typeof callback === 'function') {
        callback(accountObj);
      }
    }.bind(this, acctId, callback));
  };

  // Should we rename this to "SaveSelection" or something?
  this.checkConnection = function (bankId, callback) {
    this.getBankById(bankId, function (bank) {
      bank.checkConnection(callback);
    });
  };

  this.createBankAccount = function (payload, callback) {
    var _this5 = this;

    this.getBankAccounts(function () {
      if (_this5.presenter.hasAction('banking.accounts.create_bank_account')) {
        _this5.presenter.performAction('banking.accounts.create_bank_account', payload, function (data, response) {
          if (_this5._DEBUG) {
            console.log(_this5.pageName + ' createBankAccount() called - Calling BankAccount.js class');
          }
          var bankAccountObject = new BankAccount(_this5.presenter, data, _this5._errorHandler);
          // update bank accounts model to include newly created account
          _this5.presenter.updateModel('banking.accounts', null, callback.bind(_this5, bankAccountObject));
        });
      }
    });
  };

  this.deleteBankAccount = function (accountId, callback) {
    var _this6 = this;

    this.getBankAccountById(accountId, function (acct) {
      var index = acct._getAccountArrayIndex();
      if (_this6.presenter.hasAction('banking.accounts.bank_accounts[' + index + '].delete_bank_account')) {
        _this6.presenter.performAction('banking.accounts.bank_accounts[' + index + '].delete_bank_account', null, function () {
          // update bank accounts model to exclude deleted account
          _this6.presenter.updateModel('banking.accounts', null, callback.bind(_this6));
        });
      }
    });
  };

  this.associateProductWithBankAccount = function (accountId, product, successCallback, failureCallback) {
    this.getBankAccountById(accountId, function (acct) {
      acct.associateWithProduct(product, successCallback.bind(this, acct), failureCallback.bind(this));
    });
  };

  this.disassociateProductWithBankAccount = function (accountId, product, successCallback, failureCallback) {
    this.getBankAccountById(accountId, function (acct) {
      acct.disassociateWithProduct(product, successCallback.bind(this, acct), failureCallback.bind(this));
    });
  };

  this.getBankAccountsAssociatedWithProducts = function (productList, callback) {
    var _this7 = this;

    this.getBankAccounts(function () {
      var accountsCollection = _this7._accounts.filter(function (acct) {
        return acct.getAssociatedProducts().some(function (associatedProduct) {
          return productList.indexOf(associatedProduct) >= 0;
        }) > 0;
      });
      if (typeof callback === 'function') {
        callback(accountsCollection);
      }
    });
  };

  this.bankPlaidStatusCheck = function (id, callbacks) {
    var _this8 = this;

    this.getBankById(id, function (bk) {
      if (bk) {
        bk.checkConnection();
        var index = bk._getBanksArrayIndex();
        var bankModel = _this8.presenter.getModelProperty('banking.banks.banks[' + index + ']');
        _this8.setLastSelectedBank(bankModel);
        if (!bk.isPlaidSupported()) {
          // If Plaid is not supported but DLT is (Applies to mini flow only)
          if (bk.isDltSupported() && callbacks.onDltSupported) {
            callbacks.onDltSupported();
          } else {
            // If Plaid is not supported
            callbacks.onStatusNotSupported();
          }
        } else if (bk.isPlaidOnline()) {
          callbacks.onStatusOnline();
        } else {
          callbacks.onStatusOffline();
        }
      }
    });
  };

  this.bankVisaDirectStatusCheck = function (id, callbacks) {
    var _this9 = this;

    this.getBankById(id, function (bk) {
      if (bk) {
        bk.checkConnection();
        var index = bk._getBanksArrayIndex();
        var bankModel = _this9.presenter.getModelProperty('banking.banks.banks[' + index + ']');
        _this9.setLastSelectedBank(bankModel);
        if (bk.isVisaDirectSupported()) {
          callbacks.onStatusOnline();
        } else {
          callbacks.onStatusNotSupported();
        }
      }
    });
  };

  this.setLastSelectedBank = function (data) {
    if (typeof this.presenter.models.bankSelected === 'undefined' || !this.presenter.models.bankSelected._initialized) {
      this.presenter.createModel('bankSelected', { data: data });
    } else {
      this.presenter.updateModel('bankSelected', data);
    }
  };

  this.removeLastSelectedBank = function () {
    this.presenter.removeModelProperty('bankSelected.id');
    this.presenter.removeModelProperty('bankSelected.name');
  };

  this.createFinancialAccount = function (vdCard, successCallback, failureCallback, timeOutCallback) {
    var _this10 = this;

    this._initiatePungle(function (metaData) {
      var publicAPIKey = metaData.public_api_token;
      _this10.ps = new PungleService(_this10.presenter, metaData.environment);
      _this10.ps.createToken(publicAPIKey, vdCard, function (pungleData) {
        if (_this10.presenter.hasAction('banking.financial_accounts.create_visa_direct_financial_account')) {
          _this10.presenter.performAction('banking.financial_accounts.create_visa_direct_financial_account', { data: { token: pungleData.token } }, _this10._onCreateFinancialAccount.bind(_this10, successCallback, failureCallback, timeOutCallback));
        } else if (typeof failureCallback === 'function') {
          failureCallback({ errors: [{ code: 404, key: 'no_action_error' }] }, 404);
        }
      }, failureCallback);
    }, failureCallback, timeOutCallback);
  };

  // TODO: some placeholder methods. Will get implemented when BE delivers rel-links.
  this.getFinancialAccountById = function (id, successCallback, failureCallback) {};

  this.deleteFinancialAccountById = function (id, successCallback, failureCallback) {};

  this.getFinancialAccounts = function (successCallback, failureCallback) {
    var _this11 = this;

    this._initRootModel();
    if (!this.presenter.getModelProperty('banking.financial_accounts')) {
      this._getFinancialBankAccountsCallback = this.presenter.addCallbackToAction('account.index_visa_direct_financial_accounts', this._onFinancialAccountsModelReady.bind(this, successCallback, failureCallback));
      this.presenter.createModel('banking.financial_accounts', {
        action: 'account.index_visa_direct_financial_accounts'
      });
    } else if (!this.presenter.getModelProperty('banking.financial_accounts._initialized')) {
      $.when(this._initializedFinancialAccountsModelPromise).then(function () {
        _this11._instantiateFinancialAccountsArray(successCallback, failureCallback);
      });
    } else if (typeof successCallback === 'function') {
      this._instantiateFinancialAccountsArray(successCallback, failureCallback);
    }
  };

  this._onFinancialAccountsModelReady = function (successCallback, failureCallback, data, response) {
    this._removeGetFinancialBankAccountsCallback();
    if (!!this._connectionIssueConfig && this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'account.index_visa_direct_financial_accounts' }, { productLabel: this.productConfig.name });
      }
    } else if (response === 200) {
      this._instantiateFinancialAccountsArray(successCallback, failureCallback);
    }
    this._initializedFinancialAccountsModelPromise.resolve();
  };

  this._instantiateFinancialAccountsArray = function (successCallback, failureCallback) {
    var _this12 = this;

    this._financialAccounts = this.presenter.getModelProperty('banking.financial_accounts.visa_direct_financial_accounts');
    if (this._financialAccounts) {
      this._financialAccounts = this._financialAccounts.map(function (fa) {
        return new FinancialAccount(_this12.presenter, fa);
      });
      if (typeof successCallback === 'function') {
        successCallback(this._financialAccounts);
      }
    } else {
      this._financialAccounts = [];
      if (typeof failureCallback === 'function') {
        failureCallback({ errors: [{ code: 404, key: 'resource_not_found' }] }, 404);
      }
    }
  };

  this._removeGetFinancialBankAccountsCallback = function () {
    if (this._getFinancialBankAccountsCallback) {
      this.presenter.removeCallbackFromAction('account.index_visa_direct_financial_accounts', this._getFinancialBankAccountsCallback);
    }
  };

  this._initiatePungle = function (successCallback, failureCallback, timeOutCallback) {
    var _this13 = this;

    this.getFinancialAccounts(function () {
      if (_this13.presenter.hasAction('banking.financial_accounts.initiate_pungle')) {
        _this13.presenter.performAction('banking.financial_accounts.initiate_pungle', null, _this13._onInitiatePungle.bind(_this13, successCallback, failureCallback, timeOutCallback));
      } else if (typeof failureCallback === 'function') {
        failureCallback({ errors: [{ code: 404, key: 'no_action_error' }] }, 404);
      }
    }, failureCallback);
  };

  this._onInitiatePungle = function (successCallback, failureCallback, timeOutCallback, data, response) {
    if (this.isGeneralConnectionIssue(data, response) && typeof timeOutCallback === 'function') {
      timeOutCallback();
    } else if (!!this._connectionIssueConfig && this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'banking.financial_accounts.initiate_pungle' }, { productLabel: this.productConfig.name });
      }
    } else if (response === 200 && typeof successCallback === 'function') {
      successCallback(data, response);
    } else if (typeof failureCallback === 'function') {
      failureCallback(data, response);
    }
  };

  this._onCreateFinancialAccount = function (successCallback, failureCallback, timeOutCallback, data, response) {
    if (this.isGeneralConnectionIssue(data, response) && typeof timeOutCallback === 'function') {
      timeOutCallback();
    } else if (!!this._connectionIssueConfig && this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized) {
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: 'banking.financial_accounts.create_visa_direct_financial_account' }, { productLabel: this.productConfig.name });
      }
    } else if (response === 200 && typeof successCallback === 'function') {
      this.presenter.updateModel('banking.financial_accounts', null, successCallback.bind(this, data, response));
    } else if (typeof failureCallback === 'function') {
      failureCallback(data, response);
    }
  };
}